module.exports = __webpack_public_path__ + "static/media/java.637fe6af.svg";